import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from './pages/Login/Login';
import Admin from './pages/Admin/Admin';
import ForgetPwd from './pages/ForgetPwd/ForgetPwd';
import baseConfig from './config/BaseConfig';
import Privacy from './pages/Agreement/Privacy';
import Service from './pages/Agreement/Service';
import Agreement from './pages/Agreement/Agreement';
import About from './pages/Agreement/About';
import Contact from './pages/Agreement/Contact';

export default class App extends Component {

    componentDidMount() {
        return;
        // 西安脑电心里 使用 config.json 配置项目标题
        fetch(process.env.PUBLIC_URL + '/config.json?t=' + new Date().getTime()) // 注意路径是 `/config.json`
            .then(response => {
                if (!response.ok) {
                    throw new Error('网络响应异常');
                }
                return response.json();
            })
            .then(data => {
                if (data.title) {
                    document.title = data.title;
                }
            })
            .catch(error => {
                console.error('加载配置失败:', error);
            });
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path={baseConfig.routeUrl + '/login'} component={Login}></Route>
                    <Route path={baseConfig.routeUrl + '/forgetpwd'} component={ForgetPwd}></Route>
                    <Route path={baseConfig.routeUrl + '/service'} component={Service}></Route>
                    <Route path={baseConfig.routeUrl + '/privacy'} component={Privacy}></Route>
                    <Route path={baseConfig.routeUrl + '/agreement'} component={Agreement}></Route>
                    <Route path={baseConfig.routeUrl + '/about'} component={About}></Route>
                    <Route path={baseConfig.routeUrl + '/contact'} component={Contact}></Route>
                    <Route path={baseConfig.routeUrl + '/'} component={Admin}></Route>
                    <Redirect to={baseConfig.routeUrl + '/login'} />
                </Switch>
            </BrowserRouter>
        )
    }
}
